import { EditorState, Modifier } from "draft-js";
import * as React from "react";
import { BackendGapTag } from "./util";

export interface IAddGapButtonProps {
  editorState: EditorState;
  onChange: (state: any) => void;
}

const defaultProps: IAddGapButtonProps = {
  editorState: EditorState.createEmpty(),
  onChange: (state: EditorState) => null,
};

export default class AddGapButton extends React.Component<IAddGapButtonProps> {
  public static defaultProps = defaultProps;

  public addGap = () => {
    const { editorState, onChange } = this.props;
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      BackendGapTag,
      editorState.getCurrentInlineStyle()
    );
    onChange(EditorState.push(editorState, contentState, "insert-characters"));
  };

  public render() {
    return (
      <div className="rdw-option-wrapper" onClick={this.addGap}>
        {BackendGapTag}
      </div>
    );
  }
}
